var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgressIconMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6.5,
    stroke: "#1A1A1A",
    strokeDasharray: "2 2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.177 6.42701L7.17701 10.427C7.1538 10.4503 7.12622 10.4687 7.09587 10.4813C7.06552 10.4939 7.03299 10.5003 7.00014 10.5003C6.96729 10.5003 6.93475 10.4939 6.9044 10.4813C6.87405 10.4687 6.84648 10.4503 6.82326 10.427L5.07326 8.67701C5.02635 8.6301 5 8.56648 5 8.50014C5 8.4338 5.02635 8.37017 5.07326 8.32326C5.12017 8.27635 5.1838 8.25 5.25014 8.25C5.31648 8.25 5.3801 8.27635 5.42701 8.32326L7.00014 9.8967L10.8233 6.07326C10.8702 6.02635 10.9338 6 11.0001 6C11.0665 6 11.1301 6.02635 11.177 6.07326C11.2239 6.12017 11.2503 6.1838 11.2503 6.25014C11.2503 6.31648 11.2239 6.3801 11.177 6.42701Z",
    fill: "#1A1A1A",
    stroke: "#1A1A1A",
    strokeWidth: 0.9
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressIconMobile);
export default __webpack_public_path__ + "static/media/progressIconMobile.fbf5f4dabe7c6832b51d98b2b64a7fc6.svg";
export { ForwardRef as ReactComponent };